import CrudTable from "../components/CrudTable";
import PDFButton from "../components/PDFButton";

export default function SmartProjects() {
  return (
    <div data-testid="smart-module">
      <div className="flex items-center justify-between mb-3">
        <h1 className="card-h1" style={{ margin: 0 }}>Smart Projects</h1>
        <PDFButton endpoint="/pdf/module/smart_projects" filename="reporte_smart.pdf" label="Reporte PDF" />
      </div>
      <CrudTable
        collection="smart_projects"
        testIdPrefix="smart"
        fields={[
          { key: "name", label: "Nombre", required: true, full: true },
          { key: "description", label: "Descripción", type: "textarea", full: true },
          { key: "justification", label: "Justificación", type: "textarea", full: true },
          { key: "duration", label: "Duración" },
          { key: "equipment", label: "Equipos a utilizar", type: "textarea", full: true },
          { key: "substances", label: "Sustancias", type: "textarea", full: true },
          { key: "risks", label: "Riesgos HSE", type: "textarea", full: true },
          { key: "responsible", label: "Responsable seguimiento" },
          { key: "ops_approver", label: "Aprobador Operaciones" },
          { key: "hse_approver", label: "Aprobador HSE" },
          { key: "recommendations", label: "Recomendaciones", type: "textarea", full: true },
          { key: "comments", label: "Comentarios", type: "textarea", full: true },
          { key: "status", label: "Status", type: "select", options: ["Propuesto", "En revisión", "Aprobado", "En ejecución", "Cerrado", "Rechazado"] },
        ]}
      />
    </div>
  );
}
